import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { Link } from 'react-router-dom';
import { formatPhone } from '../../utils/phoneNumber';
import CircularProgress from '@material-ui/core/CircularProgress';
import UserAvatarEleg from '../../components/UserAvatarEleg';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import services from '../../services/services';


const COLOR = {
  null: 'grey',
  true: 'blue',
  false: 'red'
};

const TEXT = {
  null: <CircularProgress disableShrink style={{ width: 15, height: 15 }} />,
  true: 'Elegível',
  false: 'Inelegível'
};

const CardBoxTreatmentPlan = props => {
  const { data } = props;
  if (!data) {
    return null;
  }

  const { allowSeeDetails } = props;

  const status = props.isElegivel !== undefined ? props.isElegivel : true;
  const benefName = data.nome ? data.nome : data.nome_beneficiario;
  const benefNameSocial = localStorage.getItem("socialname"+data.numero_carteirinha) !== null ? localStorage.getItem("socialname"+data.numero_carteirinha) : "-";
  const benefCod = data.numero_carteirinha;
  const bottomLeftTitle = 'Telefone';
  const bottomLeftDescription = formatPhone(data.telefone_beneficiario);
  const displayEleg = allowSeeDetails ? 'no' : 'yes';
  const regANS = props.registroANS;

  const isVisible = props.registroANS == null ? false : true;  
  
  return (
    <Fragment>
      <Link to={{ pathname: '/solicitar-gto', state: { data } }}>

        <div
          data-testid="card-box-treatment-plan"
          className={`CardBoxTreatmentPlan CardBoxTreatmentPlan--${COLOR[status]} row z-depth-2`}
        >
          <div className="col s8 align-left">
            <div className="box-label box-label--top">
              <span className="box-label--name benefName">{benefName}</span>
              <span className="box-label--nameSocial benefNameSocial">Nome Social</span>
              <span className="box-label--nameSocial benefNameSocial">{benefNameSocial}</span>
              <span>&nbsp;</span>
              <span className="box-label--nameRN benefRN">Atendimento ao Recém-Nato</span>
              <span className="box-label--nameRN benefRN">N</span>
              <span>&nbsp;</span>
              <span className="box-label--nameRN benefRN">Código Beneficiário</span>
              <span className="box-label--numberCard benefCod">{benefCod}</span>
              
            </div>

            <div className="box-label" style={{display: isVisible ? 'block' : 'none'}}>
              <span className="box-label--nameRN benefRN">Registro ANS</span>
              <span className="box-label--numberCard benefCod">{regANS}</span>
              <span>&nbsp;</span>
            </div>

            <div className="box-label box-label--bottom">
              <span>{bottomLeftTitle}</span>
              <a href={`tel:${bottomLeftDescription}`}>
                <span className="box-label--dateStart bottomLeftDescription">
                  {bottomLeftDescription}
                </span>
              </a>
            </div>
          </div>
          <div className="col s4 align-right">
            <div className="box-label box-label--top">
              <span className={`box-label--consult benefElegivel noselect ${displayEleg}`}>
                {TEXT[status]}
              </span>
            </div>
            {allowSeeDetails && (
              <div className="box-label box-label--middle">
                <span className="box-label--link benefDetails" />
              </div>
            )}
          </div>
        </div>
      </Link>
    </Fragment>
  );
};

CardBoxTreatmentPlan.defaultProps = {
  allowSeeDetails: false
};

CardBoxTreatmentPlan.propTypes = {
  // data: PropTypes.arrayOf(PropTypes.any).isRequired,
  // data: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.any.isRequired,
  allowSeeDetails: PropTypes.bool,
  children: PropTypes.any
};

export default CardBoxTreatmentPlan;
